import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import PackingNotesValues from '@tKgpco/Components/PackingNotesValues';

export interface OrderPackingListAndInstructionsStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    account?: TypographyProps;
}

export const OrderPackingStyles: OrderPackingListAndInstructionsStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
            display: flex;
            flex-direction: column;
        `,
    },
    titleText: {
        variant: "h3",
        as: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    account: {
        css: css`
            font-size: 14px !important;
        `,
    },
};

const styles = OrderPackingStyles;

const OrderDetailspackingListAndInstructions: FC = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.properties.packingListAndInstructions) {
        return null;
    }

    const selectedPackingListAndIsntructions = order.properties.packingListAndInstructions?.split("|");

    return (
        <StyledWrapper {...styles.wrapper}>
            <PackingNotesValues selectedPacking={selectedPackingListAndIsntructions} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailspackingListAndInstructions,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
